import { WorkflowDocumentKinds } from "../kinds";

// 依頼文書
export class WorkflowDocumentInfo {
  public targetId: number;
  public type: WorkflowDocumentKinds;
  public documentId: number;
}
